import React, { useState } from "react";
import {
    Command,
    CommandEmpty,
    CommandGroup,
    CommandInput,
    CommandItem,
    CommandList,
} from "../../../components/ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "../../../components/ui/popover";
import { AgentMeta } from "tekkr-common/dist/model/agent/agent";
import { getIconComponent } from "../../../components/icon-picker";

interface AgentSelectorProps {
    agents: AgentMeta[];
    onSelectAgent: (agentId: string) => void;
    disabled?: boolean;
    open?: boolean;
    onOpenChange?: (open: boolean) => void;
    triggerElement: React.ReactNode;
}

export function AgentSelector({
    agents,
    onSelectAgent,
    open: controlledOpen,
    onOpenChange: controlledOnOpenChange,
    triggerElement,
}: AgentSelectorProps) {
    const [internalOpen, setInternalOpen] = useState(false);

    const open = controlledOpen !== undefined ? controlledOpen : internalOpen;
    const setOpen = controlledOnOpenChange || setInternalOpen;

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>{triggerElement}</PopoverTrigger>
            <PopoverContent className="w-[300px] p-0">
                <Command>
                    <CommandInput placeholder="Search agents..." />
                    <CommandList>
                        <CommandEmpty>No agent found.</CommandEmpty>
                        <CommandGroup>
                            {agents.map((agent) => {
                                const AgentIcon = getIconComponent(agent.icon);
                                return (
                                    <CommandItem
                                        key={agent.id}
                                        value={agent.name}
                                        onSelect={() => {
                                            onSelectAgent(agent.id);
                                            setOpen(false);
                                        }}
                                    >
                                        <AgentIcon className={"me-4 ms-1 h-4 w-4"} />
                                        <div className="flex flex-col">
                                            <span className="font-medium">{agent.name}</span>
                                            {agent.description && (
                                                <span className="line-clamp-2 text-xs text-muted-foreground">
                                                    {agent.description}
                                                </span>
                                            )}
                                        </div>
                                    </CommandItem>
                                );
                            })}
                        </CommandGroup>
                    </CommandList>
                </Command>
            </PopoverContent>
        </Popover>
    );
}
